'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var md5 = require('../md5.js');

function getApiKey(time, customHeaders, accessData) {
    if (customHeaders === void 0) { customHeaders = {}; }
    var apiKeyParams = [
        // Config.get('user.privateId') || customHeaders.privateId || '',
        // Config.get('user.sid') || customHeaders.sid || '',
        // Config.get('authInfo.device_id'),
        // Config.get('authInfo.public_app_key'),
        accessData.privateId || customHeaders.privateId || '',
        accessData.sid || customHeaders.sid || '',
        accessData.device_id,
        accessData.public_app_key,
        time
    ];
    return md5.md5(apiKeyParams.join(''));
}

exports.getApiKey = getApiKey;
